import { API_V1 } from '../config'
import { apiFetch } from './api'

export interface Tag {
  id: number
  name: string
  color: string
  organization_context: string | null
  created_at: string
  document_count: number
}

/** List tags for the given actor */
export async function listTags(actorId?: string): Promise<Tag[]> {
  const params = new URLSearchParams()
  if (actorId) params.set('actor_id', actorId)

  const query = params.toString()
  const url = query ? `${API_V1}/documents/tags/?${query}` : `${API_V1}/documents/tags/`

  const response = await apiFetch(url)
  if (!response.ok) {
    throw new Error(`Failed to fetch tags: ${response.status}`)
  }
  return response.json()
}

/** Create a new tag */
export async function createTag(
  name: string,
  color: string,
  actorId?: string,
): Promise<Tag> {
  const params = new URLSearchParams()
  if (actorId) params.set('actor_id', actorId)

  const query = params.toString()
  const url = query ? `${API_V1}/documents/tags/?${query}` : `${API_V1}/documents/tags/`

  const response = await apiFetch(url, {
    method: 'POST',
    body: JSON.stringify({ name, color }),
  })
  if (!response.ok) {
    const errorData = await response.json().catch(() => null)
    const message = errorData?.error || `Failed to create tag: ${response.status}`
    throw new Error(message)
  }
  return response.json()
}

/** Add a tag to a document */
export async function addTagToDocument(
  koblinkId: string,
  tagId: number,
  actorId?: string,
): Promise<{ message: string; tag: Tag }> {
  const body: Record<string, unknown> = { tag_id: tagId }
  if (actorId) body.actor_id = actorId

  const response = await apiFetch(
    `${API_V1}/documents/${encodeURIComponent(koblinkId)}/add-tag/`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  )
  if (!response.ok) {
    const errorData = await response.json().catch(() => null)
    const message = errorData?.error || `Failed to add tag: ${response.status}`
    throw new Error(message)
  }
  return response.json()
}

/** Remove a tag from a document */
export async function removeTagFromDocument(
  koblinkId: string,
  tagId: number,
  actorId?: string,
): Promise<{ message: string }> {
  const body: Record<string, unknown> = { tag_id: tagId }
  if (actorId) body.actor_id = actorId

  const response = await apiFetch(
    `${API_V1}/documents/${encodeURIComponent(koblinkId)}/remove-tag/`,
    {
      method: 'POST',
      body: JSON.stringify(body),
    },
  )
  if (!response.ok) {
    const errorData = await response.json().catch(() => null)
    const message = errorData?.error || `Failed to remove tag: ${response.status}`
    throw new Error(message)
  }
  return response.json()
}
